import React from 'react';
import PropTypes from 'prop-types';

function IconHeart({ stroke, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      id="heart-1"
      height={height}
    >
      <path
        data-name="layer1"
        d="M47 5c-6.5 0-12.9 4.2-15 10-2.1-5.8-8.5-10-15-10A15 15 0 0 0 2 20c0 13 11 26 30 39 19-13 30-26 30-39A15 15 0 0 0 47 5z"
        fill="none"
        stroke={stroke}
        strokeMiterlimit="10"
        strokeWidth="3"
        strokeLinejoin="round"
        strokeLinecap="round"
      ></path>
    </svg>
  );
}

IconHeart.propTypes = {
  stroke: PropTypes.string,
  height: PropTypes.number,
};

IconHeart.defaultProps = {
  stroke: 'black',
  height: 25,
};

export default IconHeart;
